<wcg-dialog
  title="Edit all {{ data.title }} notifications"
  [size]="size"
  [description]="
    'Selecting this checkbox will toggle on/off all notifications for the selected studies, resetting your custom preferences. Do you wish to continue?'
  "
>
  <div primary>
    <div class="buttons">
      <button mat-flat-button mat-button wcg-button (click)="cancel()">
        Cancel
      </button>
      <button
        mat-flat-button
        mat-button
        wcg-button
        color="primary"
        (click)="delete()"
      >
        Yes, reset my custom preferences
      </button>
    </div>
  </div>
</wcg-dialog>
